export default class NoGpsEvent {
    constructor (
        type,
        start,
        end,
        startPoint,
        endPoint
    ) {
        this.type = type
        this.start = start
        this.end = end
        this.startPoint = startPoint
        this.endPoint = endPoint
    }
}
